export const ROUTE__LOGIN = '/login';
export const ROUTE__LOGIN__ENTER_PHONE = `${ROUTE__LOGIN}/phone`;
export const ROUTE__LOGIN__ENTER_CODE = `${ROUTE__LOGIN}/code`;

export const ROUTE__DASHBOARD = '/main';
export const ROUTE__USERS = `${ROUTE__DASHBOARD}/users`;
export const ROUTE__ORDER_FULL_INFO = `${ROUTE__DASHBOARD}/orders/:id`;

export const ROUTE__USER_ACCOUNT = `${ROUTE__USERS}/:id`;
export const ROUTE__USER_ACCOUNT__INFORMATION = ROUTE__USER_ACCOUNT;
export const ROUTE__USER_ACCOUNT__BANS = `${ROUTE__USER_ACCOUNT}/bans`;
export const ROUTE__USER_ACCOUNT__UTM = `${ROUTE__USER_ACCOUNT}/utm`;
export const ROUTE__USER_ACCOUNT__ORDERS = `${ROUTE__USER_ACCOUNT}/orders`;
export const ROUTE__USER_ACCOUNT__POOLS = `${ROUTE__USER_ACCOUNT}/pools`;
export const ROUTE__USER_ACCOUNT__STAKES = `${ROUTE__USER_ACCOUNT}/stakes`;
export const ROUTE__USER_ACCOUNT__TRANSACTIONS = `${ROUTE__USER_ACCOUNT}/transactions`;
export const ROUTE__USER_ACCOUNT__TRANSACTIONS_POOL = `${ROUTE__USER_ACCOUNT}/transactions-pool`;
export const ROUTE__USER_ACCOUNT__DEPOSITS = `${ROUTE__USER_ACCOUNT}/deposits`;
export const ROUTE__USER_ACCOUNT__WITHDRAWALS = `${ROUTE__USER_ACCOUNT}/withdrawals`;

export const ROUTE__TRANSACTION_FULL_INFO = `${ROUTE__DASHBOARD}/transactions/:id`;
// The payment API needs the user, so these are nested under the user
export const ROUTE__DEPOSIT_FULL_INFO = `${ROUTE__USERS}/:userId/deposits/:id`;
export const ROUTE__WITHDRAWAL_FULL_INFO = `${ROUTE__USERS}/:userId/withdrawals/:id`;
export const ROUTE__EVENTS = `${ROUTE__DASHBOARD}/events`;
export const ROUTE__EVENT_DETAILS = `${ROUTE__EVENTS}/:event_id`;
export const ROUTE__EVENT_LOGS = `${ROUTE__EVENT_DETAILS}/logs`;
export const ROUTE__EVENT_ORDERS = `${ROUTE__EVENT_DETAILS}/orders`;
export const ROUTE__EVENT_STAKES = `${ROUTE__EVENT_DETAILS}/stakes`;
export const ROUTE__ORDERS = `${ROUTE__DASHBOARD}/orders`;
export const ROUTE__STAKES = `${ROUTE__DASHBOARD}/stakes`;
export const ROUTE__CREATE_EVENT = `${ROUTE__EVENTS}/create`;
export const ROUTE__SPORT_MATCHES = `${ROUTE__DASHBOARD}/sport-matches`;
export const ROUTE__BASKETBALL = `${ROUTE__DASHBOARD}/basketball`;

export const ROUTE__TOPICS = `${ROUTE__DASHBOARD}/topics`;
export const ROUTE__CREATE_TOPIC = `${ROUTE__TOPICS}/create`;
export const ROUTE__TOPIC_DETAILS = `${ROUTE__TOPICS}/:topic_id`;
export const ROUTE__TOPIC_POOLS = `${ROUTE__TOPIC_DETAILS}/pools`;
export const ROUTE__TOPIC_CHAT = `${ROUTE__TOPIC_DETAILS}/chat`;

export const ROUTE__PARTICIPANTS = `${ROUTE__DASHBOARD}/participants`;
export const ROUTE__PARTICIPANT_CREATE = `${ROUTE__PARTICIPANTS}/create`;
export const ROUTE__PARTICIPANT_DETAILS = `${ROUTE__PARTICIPANTS}/:participant_id`;
export const ROUTE__KYC = `${ROUTE__DASHBOARD}/kyc`;
export const ROUTE__USER_BANS = `${ROUTE__DASHBOARD}/user-bans`;
export const ROUTE__REPORTS = `${ROUTE__DASHBOARD}/reports`;
export const ROUTE__REFERRALS = `${ROUTE__DASHBOARD}/referrals`;
export const ROUTE__MARKETPLACE = `${ROUTE__DASHBOARD}/marketplace`;
export const ROUTE__MARKETPLACE_ITEM_CREATE = `${ROUTE__MARKETPLACE}/create`;
export const ROUTE__MARKETPLACE_ITEM_EDIT = `${ROUTE__MARKETPLACE}/:id`;

export const ROUTE__CATEGORIES_GROUP = `${ROUTE__DASHBOARD}/categories`;
export const ROUTE__CATEGORIES = `${ROUTE__CATEGORIES_GROUP}/theme`;
export const ROUTE__CATEGORY_CREATE = `${ROUTE__CATEGORIES}/create`;
export const ROUTE__CATEGORY_EDIT = `${ROUTE__CATEGORIES}/:id`;

export const ROUTE__SUB_CATEGORIES = `${ROUTE__CATEGORIES}/:categoryId/subcategories`;
export const ROUTE__SUB_CATEGORY_CREATE = `${ROUTE__SUB_CATEGORIES}/create`;
export const ROUTE__SUB_CATEGORY_EDIT = `${ROUTE__SUB_CATEGORIES}/:id`;

export const ROUTE__GEO_FILTER_OPTIONS = `${ROUTE__CATEGORIES_GROUP}/geo`;
export const ROUTE__GEO_FILTER_OPTION__CREATE = `${ROUTE__GEO_FILTER_OPTIONS}/create`;
export const ROUTE__GEO_FILTER_OPTION__EDIT = `${ROUTE__GEO_FILTER_OPTIONS}/:id`;

export const ROUTE__CURRENT_USER_PROFILE = '/profile';

export const ROUTE__PROMOCODES = `${ROUTE__DASHBOARD}/promocodes`;
export const ROUTE__PROMOCODE_CREATE = `${ROUTE__PROMOCODES}/create`;

export const ROUTE__TRANSACTIONS = `${ROUTE__DASHBOARD}/transactions`;
export const ROUTE__TRANSACTIONS__TRANSACTIONS = ROUTE__TRANSACTIONS;
export const ROUTE__TRANSACTIONS__POOL = `${ROUTE__TRANSACTIONS}/pool`;
export const ROUTE__TRANSACTIONS__DEPOSITS = `${ROUTE__TRANSACTIONS}/deposits`;
export const ROUTE__TRANSACTIONS__WITHDRAWALS = `${ROUTE__TRANSACTIONS}/withdrawals`;

export const ROUTE__RATES = `${ROUTE__DASHBOARD}/rates`;

export const ROUTE__BANNERS = `${ROUTE__DASHBOARD}/banners`;
export const ROUTE__BANNER_CREATE = `${ROUTE__BANNERS}/create`;
export const ROUTE__BANNER_EDIT = `${ROUTE__BANNERS}/:id`;

export const ROUTE__SETTINGS = `${ROUTE__DASHBOARD}/settings`;
export const ROUTE__SETTINGS_VOUCHERS = `${ROUTE__SETTINGS}/vouchers`;
export const ROUTE__SETTINGS_COUNTRIES = `${ROUTE__SETTINGS}/countries`;
export const ROUTE__SETTINGS_PAYMENT_METHODS = `${ROUTE__SETTINGS}/payment-methods`;
export const ROUTE__SETTINGS_PAYMENT_METHODS__PAYOUTS = `${ROUTE__SETTINGS_PAYMENT_METHODS}/payouts`;

export const ROUTE__VIDEOS = `${ROUTE__DASHBOARD}/videos`;
export const ROUTE__CREATE_VIDEO = `${ROUTE__VIDEOS}/create`;
export const ROUTE__VIDEO_DETAILS = `${ROUTE__VIDEOS}/:video_id`;

export const ROUTE__CRYPTO = `${ROUTE__DASHBOARD}/crypto`;
export const ROUTE__CRYPTO_CURRENCY_DETAILS = `${ROUTE__CRYPTO}/:currency_id`;

export const ROUTE__ONBOARDINGS = `${ROUTE__DASHBOARD}/onboardings`;
export const ROUTE__ONBOARDING_DETAILS = `${ROUTE__ONBOARDINGS}/:type`;
